import React, {Fragment} from "react";
import {Menu, MenuButton, MenuDivider, MenuHeader, MenuItem} from "@szhsin/react-menu";
import '@szhsin/react-menu/dist/index.css';
import moreMenuIcon from '../../../../../images/more-menu-icon.svg';
import studentInformationService from 'Services/StudentInformationService';
import {logSessionInfo} from "Services/logger";

export default class StudentManagementMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      student: {},
      assignment: null,
    };

    this.unassignAssessment = this.unassignAssessment.bind(this);
    this.setEarlyReader = this.setEarlyReader.bind(this);
    this.setESL = this.setESL.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = prevState || {
      student: {},
      assignment: null,
    }

    const {student = {}, assignment} = nextProps;
    if (state.student !== student) {
      state.student = student;
    }

    if(state.assignment !== assignment){
      state.assignment = assignment;
    }

    return state;
  }

  async unassignAssessment() {
    const {student, assignment} = this.state;
    this.props.onUnassign(student.id, assignment.id);
  }

  async setEarlyReader(isEarlyReader) {
    let {student} = this.state;
    student.metadata.early_reader = isEarlyReader;
    await this.updateStudentMetadata(student);
    logSessionInfo("student_management_early_reader_change", student);
    // update the UI state within the Tracking Row
    this.props.setIsEarlyReader(isEarlyReader)
  }

  async setESL(esl) {
    let {student} = this.state;
    student.metadata.esl = esl;
    await this.updateStudentMetadata(student);
    logSessionInfo("student_management_esl_change", student);
  }

  async updateStudentMetadata(student) {
    await studentInformationService.updateStudentMetadata(student.id, student.metadata);
    this.setState({student: student});
  }

  render() {
    const {student, assignment} = this.state;
    return (
      <Menu menuButton={<MenuButton disabled={this.props.disabled}><img src={moreMenuIcon} alt=""/></MenuButton>} direction="left" arrow={true}>
        {
          assignment && assignment.status === 'ASSIGNED' &&
          <Fragment>
            <MenuItem onClick={this.unassignAssessment}>Unassign Assessment</MenuItem>
            <MenuDivider/>
          </Fragment>
        }
        <MenuHeader>Student Settings</MenuHeader>
        <MenuItem type="checkbox" checked={student.metadata.early_reader} onClick={e => this.setEarlyReader(e.checked)}>Early
          Reader</MenuItem>
        <MenuItem type="checkbox" checked={student.metadata.esl} onClick={e => this.setESL(e.checked)}>Bilingual</MenuItem>
      </Menu>
    )
  }
}